enum DashboardCategory {
    Cases = '00000000-0000-0000-0000-000000000001',
    Tasks = '00000000-0000-0000-0000-000000000002',
}
export default DashboardCategory;
